/**
 * WaveDivider — seamless transition between two flat-colored sections.
 *
 * Usage: drop between two sections. Set `topColor` to the section ABOVE
 * (the area the wave is "carved" out of) and `bottomColor` to the section
 * BELOW (the area the wave fills toward).
 *
 * `color` is kept as a back-compat alias for `bottomColor`.
 */
export function WaveDivider({
  flip = false,
  color,
  topColor,
  bottomColor,
}: {
  flip?: boolean;
  color?: string;
  topColor?: string;
  bottomColor?: string;
}) {
  const top = topColor ?? "transparent";
  const bottom = bottomColor ?? color ?? "var(--background)";
  return (
    <div
      className={`pointer-events-none -my-px block w-full overflow-hidden leading-[0] ${flip ? "rotate-180" : ""}`}
      style={{ backgroundColor: top }}
      aria-hidden
    >
      <svg
        viewBox="0 0 1440 92"
        preserveAspectRatio="none"
        className="block h-[60px] w-full sm:h-[90px]"
      >
        {/* Path extends 2px past viewBox bottom to guarantee no sub-pixel seam */}
        <path
          d="M0,40 C240,90 480,90 720,55 C960,20 1200,20 1440,55 L1440,92 L0,92 Z"
          fill={bottom}
        />
      </svg>
    </div>
  );
}
